import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FilesService } from 'src/app/core/services/files.service';
import * as ExcelJS from 'exceljs';
import { CSV_STRING, EXCEL_STRING } from 'src/app/components/casos/ver-tarea/constants/file.constant';

@Component({
  selector: 'file-excel-show-view',
  templateUrl: './file-excel-show-view.component.html',
  styleUrls: ['./file-excel-show-view.component.scss'],
})
export class FileExcelShowViewComponent implements OnInit {
  @Input() isExternal: boolean = true;
  @Input() url: string = null;
  @Input() fileType: string = null;
  @Input() data: any[][] = null;
  header: any[] = [];
  info: any[][] = [];
  infoAll: any[][] = [];
  itemsPorPagina = 100;
  totalPaginas = 1;
  paginaActual = 1;
  procesando: boolean = false;
  procesandoStatus: string = 'Procesando archivo...';
  paginaDeseada: number = 1;

  constructor(
    private readonly filesService: FilesService,
  ) {
  }

  ngOnInit() {
    if(this.isExternal){
      this.loadContent();
    }else{
      this.infoAll = this.data;
      this.organizarData();
    }
  }

  organizarData() {
    this.header = this.infoAll.length > 0 ? this.infoAll[0] : [];
    // Remover la primera fila (encabezados) de los datos principales
    this.infoAll = this.infoAll.slice(1);

    if (this.infoAll.length > 100) {

      this.totalPaginas = Math.ceil(this.infoAll.length / this.itemsPorPagina);
      // 1. Calcular el índice inicial (donde comienza el corte)
      const indiceInicio = (this.paginaActual - 1) * this.itemsPorPagina;

      // 2. Calcular el índice final (donde termina el corte, no incluido)
      const indiceFin = indiceInicio + this.itemsPorPagina;

      // 3. Aplicar slice() a los datos completos para obtener solo la página
      this.info = this.infoAll.slice(indiceInicio, indiceFin);
    }else{
      this.info = this.infoAll; //.slice(0, 100);
    }
    this.procesando = false;
  }// (Continuación del Componente)

  aplicarPaginado(): void {
    // 1. Calcular el índice inicial (donde comienza el corte)
    const indiceInicio = (this.paginaActual - 1) * this.itemsPorPagina;
    
    // 2. Calcular el índice final (donde termina el corte, no incluido)
    const indiceFin = indiceInicio + this.itemsPorPagina;
    
    // 3. Aplicar slice() a los datos completos para obtener solo la página
    this.info = this.infoAll.slice(indiceInicio, indiceFin);
    
  }

  cambiarPagina(delta: number): void {
    const nuevaPagina = this.paginaActual + delta;

    // 1. Validar que la nueva página esté dentro de los límites
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      
      // 2. Aplicar el filtro para mostrar los datos de la nueva página
      this.aplicarPaginado();
    }
  }

  isFormulaValue(val: any): val is ExcelJS.CellFormulaValue | ExcelJS.CellSharedFormulaValue {
    return typeof val === 'object' && val !== null && ('formula' in val || 'sharedFormula' in val) && 'result' in val;
  }

  detectarDelimitador(texto: string): string {
    const delimitadores = [',', ';', '\t', '|'];
    const puntuaciones = delimitadores.map(delim => ({
      delim,
      count: texto.split('\n')
        .map(linea => linea.split(delim).length)
        .reduce((a, b) => a + b, 0)
    }));

    // Ordenar por el que más divisiones genera
    puntuaciones.sort((a, b) => b.count - a.count);
    return puntuaciones[0].delim;
  }

  actualizarDataFile(data) {
    this.infoAll = data;
    this.organizarData();
  }

  async loadContent() {
    try {
      const split = this.url.split('/');
      const name = split[split.length - 1];

      let blob = (await this.filesService
        .getFileByArrayBuffer(name)
        .toPromise());
        
      this.procesandoStatus = 'Procesando archivo...';
      this.procesando = true;

      if (
        this.fileType === EXCEL_STRING
      ) {

        const workbook = new ExcelJS.Workbook();
        const buffer = await blob.arrayBuffer();
        await workbook.xlsx.load(buffer);

        const worksheet = workbook.worksheets[0];
        const data: any[][] = [];

        worksheet.eachRow((row) => {
          if (row.hasValues) {
            const valuesOg = Array.isArray(row.values) ? row.values.slice(1) : [];
            const values = valuesOg.map(val => {
              if (this.isFormulaValue(val)) {
                return val.result ?? '[Sin resultado]'; // Muestra el resultado evaluado o un placeholder
              } else {
                return val;
              }
            });
            data.push(values);
          }
        });
        this.infoAll = data;
        this.organizarData();
        return data;
      }
      else if (
        this.fileType === CSV_STRING
      ) {
        let aux;
        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result as string;
          const delimitador = this.detectarDelimitador(text);
          const aux = text
            .split('\n')
            .map(row => row.trim().split(delimitador).map(cell => cell.replace(/"/g, '')));
          this.actualizarDataFile(aux);
        };
        reader.readAsText(blob);
        return aux;
      }

    } catch (error) {
      this.procesandoStatus = 'Error procesando archivo...';
      console.error('Error en el metodo getFileByArrayBuffer:', error);
      throw error;
    }
    return null;
  }
  
  irAPagina() { 
   if (this.paginaDeseada >= 1 && this.paginaDeseada <= this.totalPaginas) {
      this.paginaActual = this.paginaDeseada;
      this.aplicarPaginado();
    }
  }



}